import { render, staticRenderFns } from "./PerkDetail.vue?vue&type=template&id=55ce48d1&"
import script from "./PerkDetail.vue?vue&type=script&lang=js&"
export * from "./PerkDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports